module.exports = __webpack_public_path__ + "static/media/calendar-chat.37c4e16d.png";